import { useState } from 'react';
import Modal from '@/components/common/Modal/Modal';

const ActionModal = ({ isOpen, onClose, title, type, metadata, onConfirm }) => {
  const [rol, setRol] = useState('operador');
  const [motivo, setMotivo] = useState('');
  const [loading, setLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleSubmit = () => {
    setShowConfirm(true);
  };

  const handleConfirm = async () => {
    setLoading(true);
    await onConfirm(type === 'aprobar' ? { rol } : { motivo });
    setLoading(false);
    onClose();
    setShowConfirm(false);
  };

  const handleBack = () => {
    setShowConfirm(false);
  };

  if (showConfirm) {
    return (
      <Modal isOpen={isOpen} onClose={onClose} title="Confirmar acción" size="sm">
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <p style={{ fontSize: '16px', marginBottom: '20px' }}>
            {type === 'aprobar' 
              ? '¿Estás seguro de que deseas APROBAR esta solicitud?' 
              : '¿Estás seguro de que deseas RECHAZAR esta solicitud?'}
          </p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
            <button className="btn btn-outline" onClick={handleBack} disabled={loading}>
              Volver
            </button>
            <button 
              className={`btn ${type === 'aprobar' ? 'btn-success' : 'btn-danger'}`} 
              onClick={handleConfirm}
              disabled={loading}
            >
              {loading ? 'Procesando...' : 'Sí, confirmar'}
            </button>
          </div>
        </div>
      </Modal>
    );
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="sm"
      footer={
        <>
          <button className="btn btn-outline" onClick={onClose} disabled={loading}>
            Cancelar
          </button>
          <button
            className={`btn ${type === 'aprobar' ? 'btn-success' : 'btn-danger'}`}
            onClick={handleSubmit}
            disabled={loading || (type === 'rechazar' && !motivo.trim())}
          >
            {type === 'aprobar' ? 'Aprobar' : 'Rechazar'}
          </button>
        </>
      }
    >
      {type === 'aprobar' && metadata?.correo && (
        <div className="form-group">
          <label>Rol para el usuario</label>
          <select className="form-control" value={rol} onChange={e => setRol(e.target.value)}>
            <option value="operador">Operador</option>
            <option value="consultor">Consultor</option>
            <option value="admin">Administrador</option>
          </select>
        </div>
      )}
      {type === 'rechazar' && (
        <div className="form-group">
          <label>Motivo del rechazo</label>
          <textarea
            className="form-control"
            rows={3}
            value={motivo}
            onChange={e => setMotivo(e.target.value)}
            placeholder="Explica por qué se rechaza esta solicitud..."
          />
        </div>
      )}
      {type === 'aprobar' && metadata?.nombres && (
        <p style={{ marginTop: '16px' }}>
          Se aprobará a <strong>{metadata.nombres} {metadata.apellidos}</strong>.
        </p>
      )}
      {type === 'aprobar' && !metadata?.nombres && metadata?.nombre && (
        <p style={{ marginTop: '16px' }}>
          Se aprobará al usuario <strong>{metadata.nombre}</strong>.
        </p>
      )}
    </Modal>
  );
};

export default ActionModal;
